var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkshops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2499 5.24994C12.0972 5.40572 12.0117 5.61515 12.0117 5.83328C12.0117 6.0514 12.0972 6.26084 12.2499 6.41661L13.5832 7.74994C13.739 7.90263 13.9484 7.98816 14.1665 7.98816C14.3847 7.98816 14.5941 7.90263 14.7499 7.74994L17.8915 4.60828C18.3106 5.53427 18.4375 6.56597 18.2553 7.5659C18.0731 8.56582 17.5905 9.48648 16.8718 10.2052C16.1531 10.9239 15.2324 11.4065 14.2325 11.5887C13.2326 11.7708 12.2009 11.644 11.2749 11.2249L5.51655 16.9833C5.18503 17.3148 4.73539 17.501 4.26655 17.501C3.79771 17.501 3.34807 17.3148 3.01655 16.9833C2.68503 16.6518 2.49878 16.2021 2.49878 15.7333C2.49878 15.2644 2.68503 14.8148 3.01655 14.4833L8.77488 8.72494C8.35585 7.79895 8.22898 6.76725 8.41117 5.76732C8.59335 4.7674 9.07595 3.84674 9.79465 3.12804C10.5133 2.40935 11.434 1.92675 12.4339 1.74456C13.4339 1.56237 14.4656 1.68925 15.3915 2.10828L12.2582 5.24161L12.2499 5.24994Z",
    stroke: "#4B5563",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshops);
export default __webpack_public_path__ + "static/media/workshops.e3c1027ea52dae8aab6a9b879367619f.svg";
export { ForwardRef as ReactComponent };